import { Modal } from "antd";
import styled from "styled-components";

export const LoaderModal = styled(Modal)`
  .ant-modal-close {
    display: none;
  }

  .ant-modal-content {
    border-radius: 10px;
  }

  .ant-modal-body {
    display: flex;
    flex-flow: row nowrap;
    gap: 1em;
    justify-content: flex-start;
    align-items: center;

    .logoImg {
      width: 22%;
      min-width: 75px;
      display: flex;
      align-items: center;
      justify-content: center;

      img {
        width: 100%;
        height: 100%;
        object-fit: contain;
      }
    }

    .loadingContent {
      display: flex;
      flex-flow: column;
      align-items: flex-start;
      justify-content: center;
      gap: 5px;

      p {
        margin: 0;
        font-size: 16px;
        font-weight: 400;
      }
    }
  }
`;

export const LoaderSign = styled.div`
  width: fit-content;
  font-weight: bold;
  font-family: monospace;
  font-size: 30px;
  background: radial-gradient(circle closest-side, #000 94%, #0000)
    right/calc(200% - 1em) 100%;
  animation: l24 1s infinite alternate linear;
  ::before {
    content: "Loading...";
    line-height: 1em;
    color: #0000;
    background: inherit;
    background-image: radial-gradient(circle closest-side, #fff 94%, #000);
    -webkit-background-clip: text;
    background-clip: text;
  }

  @keyframes l24 {
    100% {
      background-position: left;
    }
  }
`;
